// LinkSubstringHashtag.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const LinkSubstringHashtag = ({ hashtag, via }) => {
  const hashtagText = hashtag.replace('#', '').trim();
  return (
    <StyledLinkSubstringHashtag to={`/hashtag/${hashtagText}/${via}`}>
      {hashtag}
    </StyledLinkSubstringHashtag>
  );
};

LinkSubstringHashtag.propTypes = {
  hashtag: PropTypes.string,
  via: PropTypes.string,
};

LinkSubstringHashtag.defaultProps = {
  hashtag: '',
  via: 'flix',
};

const StyledLinkSubstringHashtag = styled(Link)`
  font-size: inherit;
  font-weight: inherit;
  line-height: 1;
  color: #c8c8c8;
  :hover {
    text-decoration: underline;
  }
`;

export default LinkSubstringHashtag;
